import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;

export interface IOcrResponse {
  language: string | null;
  textAngle: number | null;
  orientation: string | null;
  regions: IOcrResponseRegion[] | null;
}

export interface IOcrResponseRegion {
  boundingBox: string | null;
  lines: IOcrResponseLine[] | null;
}

export interface IOcrResponseLine {
  boundingBox: string | null;
  words: IOcrResponseWord[] | null;
}

export interface IOcrResponseWord {
  boundingBox: string | null;
  text: string | null;
}

export class BoundingBox {
  dx: number;
  dy: number;
  dw: number;
  dh: number;
  constructor(string: string, scale: number = 1) {
    const position = string.split(',').map(v => Number.parseInt(v, 10));
    this.dx = position[0] * scale;
    this.dy = position[1] * scale;
    this.dw = position[2] * scale;
    this.dh = position[3] * scale;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ComputerVisionService {

  constructor(private http: HttpClient) { }

  ocr(file: Blob | File) {
    const body: FormData = new FormData();
    body.set('image', file);
    const apiKey = environment.computerVisionService.apiKey;
    const apiUrl = `${environment.computerVisionService.apiUrl}/ocr?language=ja&detectOrientation=true`;
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': apiKey
    });
    return this.http.post<IOcrResponse>(apiUrl, body, { headers });
  }

  analyzeResponse(res: IOcrResponse) {
    let paidOn = moment();
    let amount = 0;
    if (res.regions) {
      const lines = res.regions
        .reduce(
          (acc, cur) => {
            if (cur.lines) {
              return [...acc, ...cur.lines];
            } else {
              return acc;
            }
          }, [] as IOcrResponseLine[])
        .map(
          line => {
            if (line.boundingBox && line.words) {
              return {
                box: new BoundingBox(line.boundingBox),
                text: line.words.map(word => word.text).join('')
              };
            } else {
              return {
                box: null,
                text: ''
              };
            }
          });

      paidOn = (() => {
        const stringDate = lines
          .map(line => (line.text.match(/\d{4}\/\d{1,2}\/\d{1,2}/) || [])[2])
          .find(a => a != null)
          || (lines
            .map(line => (line.text.match(/\d{4}年\d{1,2}月\d{1,2}日/) || [])[0])
            .find(a => a != null)
            || '')
            .replace(/[年月日]/g, '/');
        return isFinite(new Date(stringDate).valueOf()) ? moment(new Date(stringDate)) : moment();
      })();

      amount = + (() => {
        const totalMatches = lines
          .map(line => {
            return {
              box: line.box,
              text: (line.text.match(/([\xA53\\Yy][\d,]+)|([\d,]+円)/g) || [])[0]
            };
          })
          .filter(a => a.text != null)
          .sort((a, b) => (a.box && b.box && a.box.dh < b.box.dh) ? 0 : -1);
        return totalMatches[0].text != null ? totalMatches[0].text.replace(/[\xA53\\Yy円,]/g, '') : '0';
      })();
    }
    return { paidOn: paidOn.toDate(), amount };
  }
}
